import React, { useEffect, useState } from 'react';
import styles from './euanabarr0s3.module.scss';
import perfil from './src/perfil.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const EMAIL = 'Contatoeuanabarros@gmail.com';
const WHATSAPP_NUMBER = '557499064249';
const WHATSAPP_MSG = 'Olá! Vim pelo link na bio e gostaria de falar sobre contato e parceria.';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;
const INSTAGRAM_URL =
    'https://www.instagram.com/euanabarr0s?utm_source=ig_web_button_share_sheet&stkn=ZDNlZDc0MzIxNw==';
const TIKTOK_URL = 'https://www.tiktok.com/@euanabarross?is_from_webapp=1&sender_device=pc';
const SHOPEE_URL = 'https://collshp.com/euanabarr0s?view=storefront';
const ICON_COLOR = '#f7f1ea';

const marcas = [
    { image: require('./src/marcas/1.png'), name: 'Saint Germain' },
    { image: require('./src/marcas/2.png'), name: 'Gocase' },
    { image: require('./src/marcas/3.png'), name: 'Riachuelo' },
    { image: require('./src/marcas/4.png'), name: 'Gummy' },
    { image: require('./src/marcas/5.png'), name: 'Ápice Cosméticos' },
];

type ContactCard = {
    id: number;
    image: string;
    brand: string;
    modal: 'contact';
};

type SoonCard = {
    id: number;
    image: string;
    brand: string;
    modal: 'soon';
};

type LinkCard = {
    id: number;
    image: string;
    brand: string;
    link: string;
    modal?: false;
};

type CardItem = ContactCard | SoonCard | LinkCard;

const cardImages: CardItem[] = [
    {
        id: 1,
        image: require('./src/cards/1.png'),
        brand: 'Contato e Parceria',
        modal: 'contact',
    },
    {
        id: 2,
        image: require('./src/cards/2.png'),
        brand: 'Vitrine Shopee',
        link: SHOPEE_URL,
    },
    {
        id: 3,
        image: require('./src/cards/3.png'),
        brand: 'TikTok',
        link: TIKTOK_URL,
    },
    {
        id: 4,
        image: require('./src/cards/4.png'),
        brand: 'Mídia Kit',
        modal: 'soon',
    },
];

const Euanabarr0s3: React.FC = () => {
    const [openModal, setOpenModal] = useState<'contact' | 'soon' | null>(null);

    useEffect(() => {
        if (!openModal) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setOpenModal(null);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [openModal]);

    return (
        <div className={styles.euanabarr0s3}>
            <div className={styles.container}>
                <img src={perfil} alt="Ana Barros" className={styles.perfil} />
                <div className={styles.socialRow}>
                    <a href={`mailto:${EMAIL}`} className={styles.socialLink} aria-label="E-mail">
                        <svg
                            height="24"
                            width="24"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                fill={ICON_COLOR}
                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                            />
                        </svg>
                    </a>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="Instagram"
                    >
                        <InstagramIcon height="24" color={ICON_COLOR} />
                    </a>
                    <a
                        href={TIKTOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="TikTok"
                    >
                        <TiktokIcon height="22" color={ICON_COLOR} />
                    </a>
                </div>
                <div className={styles.cards}>
                    {cardImages.map((card) =>
                        card.modal ? (
                            <button
                                type="button"
                                key={card.id}
                                className={styles.card}
                                onClick={() => setOpenModal(card.modal)}
                                aria-label={`Abrir ${card.brand}`}
                            >
                                <img src={card.image} alt={card.brand} />
                            </button>
                        ) : (
                            <a
                                href={card.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={card.id}
                                className={styles.card}
                            >
                                <img src={card.image} alt={card.brand} />
                            </a>
                        )
                    )}
                </div>
                <div className={styles.marcas} aria-label="Marcas">
                    <div className={styles.marcasTrack}>
                        {[0, 1].map((loop) => (
                            <div
                                className={styles.marcasGroup}
                                key={loop}
                                aria-hidden={loop === 1}
                            >
                                {marcas.map((marca) => (
                                    <div className={styles.marca} key={`${loop}-${marca.name}`}>
                                        <img
                                            src={marca.image}
                                            alt={loop === 0 ? marca.name : ''}
                                            decoding="async"
                                        />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {openModal ? (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setOpenModal(null)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="euanabarr0s3-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setOpenModal(null)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>
                        {openModal === 'contact' ? (
                            <>
                                <p className={styles.modalEyebrow}>Parcerias</p>
                                <h2 id="euanabarr0s3-modal-title" className={styles.modalBrand}>
                                    Contato e Parceria
                                </h2>
                                <div className={styles.contactActions}>
                                    <a href={`mailto:${EMAIL}`} className={styles.contactBtnEmail}>
                                        <svg
                                            height="22"
                                            width="22"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                                            />
                                        </svg>
                                        <span>E-mail</span>
                                    </a>
                                    <a
                                        href={WHATSAPP_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={styles.contactBtnWhatsapp}
                                    >
                                        <WhatsappIcon height="22" color="currentColor" />
                                        <span>WhatsApp</span>
                                    </a>
                                </div>
                            </>
                        ) : (
                            <>
                                <p className={styles.modalEyebrow}>Em breve</p>
                                <h2 id="euanabarr0s3-modal-title" className={styles.modalBrand}>
                                    Mídia Kit
                                </h2>
                                <p className={styles.modalText}>
                                    Este conteúdo estará disponível em breve.
                                </p>
                            </>
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default Euanabarr0s3;
